/**
 * Maps media tracks with the dscpControls provided to ensure the correct senders are set up with the
 * proper networkPriority
 * @param {Array<Track>} audioTracks The list of audio tracks
 * @param {Array<Track>} videoTracks The list of video tracks
 * @param {Array<Track>} screenTracks The list of screen tracks
 * @param {Object} dscpControls The DSCP controls provided
 * @return {Object} An object map of track: dscpSetting for all applicable tracks
 */
export function getTrackDscpMapping (audioTracks, videoTracks, screenTracks, dscpControls) {
  const dscpTrackMapping = {}
  if (dscpControls) {
    if (dscpControls.screenNetworkPriority) {
      for (const screenTrack of screenTracks) {
        dscpTrackMapping[screenTrack.id] = dscpControls.screenNetworkPriority
      }
    }
    if (dscpControls.audioNetworkPriority) {
      for (const audioTrack of audioTracks) {
        dscpTrackMapping[audioTrack.id] = dscpControls.audioNetworkPriority
      }
    }
    if (dscpControls.videoNetworkPriority) {
      for (const videoTrack of videoTracks) {
        dscpTrackMapping[videoTrack.id] = dscpControls.videoNetworkPriority
      }
    }
  }

  return dscpTrackMapping
}
